export const CREATE_PRODUCT_COLOR = 'CREATE_PRODUCT_COLOR'
export const GET_LIST_PRODUCT_COLOR = 'GET_LIST_PRODUCT_COLOR'
export const DETAIL_PRODUCT_COLOR = 'DETAIL_PRODUCT_COLOR'
export const PATCH_PRODUCT_COLOR = 'PATCH_PRODUCT_COLOR'
